import { theme as pdcTheme, overrideComponents, PDCCreateTheme } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";

const projectPalette = {
    light: {
        text: {
            primary: "#3c3d4f",
            secondary: "#6f6f83",
            disabled: "#B1B5BA",
        },
        constant: {
            black: "#000000",
            white: "#FFFFFF",
        },
    },
    dark: {
        background: {
            default: "#2B2B31",
            paper: "#2B2B31",
        },
        common: {
            black: "#FFFFFF",
            white: "#2B2B31",
        },
        constant: {
            black: "#000000",
            white: "#FFFFFF",
        },
        primary: {
            A700: "#2E2E31",
            A400: "#87878F",
            A200: "#BEC0C9",
            A100: "#D1D2D9",
            900: "#F6F7FF",
            800: "#EFF0FF",
            700: "#E7E9FF",
            600: "#C2C8FE",
            500: "#96A4FE",
            400: "#6280FF",
            300: "#2763EA",
            200: "#1352FF",
            100: "#003BF0",
            50: "#0022D9",
            main: "#6280FF",
            light: "#2763EA",
            dark: "#F6F7FF",
            contrastText: "#ffffff",
        },
        secondary: {
            900: "#BDC2D4",
            800: "#939BB7",
            700: "#6B769A",
            600: "#4D5A87",
            500: "#4A5E9F",
            400: "#2A396D",
            300: "#1B2856",
            200: "#11193F",
            100: "#04060F",
            50: "#03040A",
            main: "#6B769A",
            light: "#4A5E9F",
            dark: "#BDC2D4",
            contrastText: "#ffffff",
        },
        success: {
            900: "#59B445",
            800: "#39A71C",
            700: "#2F9812",
            600: "#218701",
            500: "#0F7600",
            400: "#0E6F00",
            300: "#0D6700",
            200: "#0C5E01",
            100: "#0A5600",
            50: "#094D00",
            main: "#2F9812",
            light: "#0F7600",
            dark: "#59B445",
            contrastText: "#ffffff",
        },
        info: {
            900: "#0783FF",
            800: "#1670EB",
            700: "#1C5DD8",
            600: "#213DB9",
            500: "#1532AD",
            400: "#1430A4",
            300: "#132E9C",
            200: "#122B93",
            100: "#112889",
            50: "#10247C",
            main: "#1C5DD8",
            light: "#1532AD",
            dark: "#0783FF",
            contrastText: "#ffffff",
        },
        warning: {
            900: "#FFA927",
            800: "#FB8F01",
            700: "#F57F00",
            600: "#EF6F00",
            500: "#E65400",
            400: "#DB5001",
            300: "#D14D01",
            200: "#C54800",
            100: "#B64301",
            50: "#AD4001",
            main: "#F57F00",
            light: "#E65400",
            dark: "#FFA927",
            contrastText: "#ffffff",
        },
        error: {
            900: "#FF4F20",
            800: "#FD491B",
            700: "#EF4016",
            600: "#E13A11",
            500: "#C82B06",
            400: "#BE2805",
            300: "#B32605",
            200: "#A72405",
            100: "#9D2104",
            50: "#8F1D02",
            main: "#EF4016",
            light: "#C82B06",
            dark: "#FF4F20",
            contrastText: "#ffffff",
        },
        grey: {
            900: "#D5D5D5",
            800: "#B0B0B0",
            700: "#999999",
            600: "#686868",
            500: "#555555",
            400: "#373737",
            300: "#171717",
            200: "#131313",
            100: "#101010",
            50: "#0B0B0B",
            main: "#686868",
            light: "#131313",
            dark: "#D5D5D5",
            contrastText: "#000000",
        },
        greySecondary: {
            A700: "#C9D4F4",
            A400: "#7085D0",
            A200: "#5174F4",
            A100: "#2F3E72",
            900: "#E7E7F2",
            800: "#DFDFEE",
            700: "#D0D0DF",
            600: "#B6B6CA",
            500: "#9898AD",
            400: "#83839A",
            300: "#6F6F83",
            200: "#5B5B6F",
            100: "#3C3D4F",
            50: "#353647",
            main: "#DFDFEE",
            light: "#6F6F83",
            dark: "#E7E7F2",
            contrastText: "#2B2B31",
        },
        text: {
            primary: "#DFDFEE",
            secondary: "#B6B6CA",
            disabled: "#B1B5BA",
        },
        divider: "#3C3D4F",
        action: {
            active: "rgba(255, 255, 255, 0.54)",
            hover: "rgba(255, 255, 255, 0.04)",
            hoverOpacity: 0.04,
            selected: "rgba(255, 255, 255, 0.08)",
            selectedOpacity: 0.08,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12,
        },
    },
};
export const projectTheme = {
    ...pdcTheme,
    palette: {
        ...pdcTheme?.palette,
        ...(window.location.pathname.indexOf("/library/") === 0 ? projectPalette.dark : projectPalette.light), //Palette mode가 dark인지 light인지에 따라 색상을 다르게 설정
        mode: window.location.pathname.indexOf("/library/") === 0 ? "dark" : "light",
        etc: {
            purple400: "#8660D9",
            purple500: `#5F62E5`,
            purple600: "#7047F3",
            red500: "#EF4B4B",
            blue400: "#5D8FFF",
            blue500: "#405FFF",
            gray300: "#7182A6",
            gray500: "#3F485A",
            pink300: "#FF92AE",
            pink500: "#E86894",
            pink700: "#EE266B",
            orange500: "#FFAA31",
            orange700: "#E07F2D",
            mint300: "#16E1B4",
            mint500: "#009EA0",
            mint700: "#3F585A",
            green500: "#65A93B",
            green600: "#397A11",
            yellow500: "#F2DB0F",
            googleCloudCdnLight: "#FEBA02",
        },
    },
    typography: {
        ...pdcTheme.typography,
    },
    mixins: {
        toolbar: {
            minHeight: `56px`,
            "@media (min-width: 600px)": {
                minHeight: "56px",
            },
        },
    },
    breakpoints: {
        ...pdcTheme.breakpoints,
        values: {
            ...pdcTheme.breakpoints.values,
            xxxl: 1650,
        },
    },
    zIndex: {
        appBar: 500,
        drawer: 500,
        modal: 900,
    },
    // spacing: (factor) => `${factor*0.5}rem`
};

export const projectOverrideTheme = {
    ...projectTheme,
    components: {
        ...overrideComponents(projectTheme),
        MuiCssBaseline: {
            styleOverrides: (theme) => ({
                body: {
                    transition: "background-color 0.3s ease",
                    backgroundColor: theme.palette.common.white,
                    color: theme.palette.greySecondary.main,
                },
                html: {
                    overflow: "hidden",
                    fontSize: "16px",
                    height: "100%",
                },
                "#root": {
                    height: "100%",
                },
                ".container": {
                    height: "100%",
                },
                a: {
                    color: "inherit",
                    textDecoration: "none",
                    "&:focus": {
                        outline: 0,
                    },
                    "&:hover, &:active": {
                        outline: 0,
                    },
                },
                "main::-webkit-scrollbar, div::-webkit-scrollbar, ul::-webkit-scrollbar": {
                    width: "14px",
                    height: "14px",
                },
                "main::-webkit-scrollbar-corner, div::-webkit-scrollbar-corner, ul::-webkit-scrollbar-corner": {
                    backgroundColor: theme.palette.common.white,
                },
                "main::-webkit-scrollbar-track, div::-webkit-scrollbar-track, ul::-webkit-scrollbar-track": {
                    background: "transparent",
                },
                "main::-webkit-scrollbar-thumb, div::-webkit-scrollbar-thumb, ul::-webkit-scrollbar-thumb": {
                    backgroundColor: alpha(theme.palette.greySecondary.main, 0.16),
                    borderRadius: "8px",
                    backgroundClip: "padding-box",
                    border: "4px solid transparent",
                },
                ".MuiList-root:has(.MuiDivider-root)::-webkit-scrollbar-track": {
                    borderLeft: "1px solid #dfdfee",
                },
                '.MuiButtonBase-root[aria-expanded="true"]': {
                    backgroundColor: `rgba(0, 0, 0, 0.04)`,
                },
                ".MuiInputBase-root .MuiInputBase-input::-webkit-input-placeholder": {
                    opacity: 1,
                    color: theme.palette.greySecondary[400],
                },
                button: {
                    margin: 0,
                    padding: 0,
                    border: "none",
                    backgroundColor: "transparent",
                },
                address: {
                    fontStyle: "normal",
                },
                ".modal-footer button": {
                    marginLeft: "6px",
                },
                ".MuiPickersDay-root, .MuiPickersYear-yearButton": {
                    "&.Mui-selected:hover": {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                    },
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    },
                    "&:focus": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.12),
                        "&.Mui-selected": {
                            backgroundColor: `${theme.palette.primary.main} !important`,
                        },
                    },
                    "&:disabled": {
                        color: theme.palette.greySecondary.main,
                    },
                    "&.MuiPickersDay-today": {
                        "&:hover": {
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                        },
                        "&:focus": {
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.12),
                        },
                    },
                },
                ".MuiPaper-root": {
                    backgroundImage: "none !important",
                },
                ".MuiModal-root input[type='text']:not([class*='MuiInputBase-input'])": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light}`,
                    borderRadius: theme.spacing(0.25),
                    color: theme.palette.greySecondary.main,
                    "&:hover": {
                        border: `1px solid ${theme.palette.primary.main}`,
                    },
                },
                ".DateRangePickerInput": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    "& div": {
                        backgroundColor: theme.palette.background.default,
                    },
                    "& div.DateRangePickerInput_arrow::after": {
                        backgroundColor: theme.palette.background.default,
                    },
                },
                ".select2-selection__control": {
                    backgroundColor: `${theme.palette.background.default} !important`,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    borderRadius: theme.spacing(0.25),
                },
                ".category-select .category-group": {
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                },
                ".tags-inputs .tags": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    borderRadius: theme.spacing(0.25),
                    "& textarea": {
                        color: theme.palette.greySecondary.main,
                    },
                },
                ".MuiTable-root": {
                    "& th": {
                        boxShadow: "none !important",
                    },
                },
                ".MuiTextField-root .MuiOutlinedInput-root": {
                    backgroundColor: theme.palette.background.default,
                    "& .Mui-disabled": {
                        backgroundColor: theme.palette.background.default,
                    },
                },
                "textarea.MuiInputBase-inputMultiline": {
                    minHeight: "unset",
                },
                ".MuiBackdrop-root:not(.MuiBackdrop-invisible)": {
                    backgroundColor: `${alpha(theme.palette.constant.black, 0.3)} !important`,
                },
                "input[type='text']:-webkit-autofill, input[type='text']:-webkit-autofill:hover, input[type='text']:-webkit-autofill:focus, input[type='text']:-webkit-autofill:active, input[type='password']:-webkit-autofill, input[type='password']:-webkit-autofill:hover, input[type='password']:-webkit-autofill:focus, input[type='password']:-webkit-autofill:active, input[type='number']:-webkit-autofill, input[type='number']:-webkit-autofill:hover, input[type='number']:-webkit-autofill:focus, input[type='number']:-webkit-autofill:active, input[type='tel']:-webkit-autofill, input[type='tel']:-webkit-autofill:hover, input[type='tel']:-webkit-autofill:focus, input[type='tel']:-webkit-autofill:active, input[type='url']:-webkit-autofill, input[type='url']:-webkit-autofill:hover, input[type='url']:-webkit-autofill:focus, input[type='url']:-webkit-autofill:active, input[type='email']:-webkit-autofill, input[type='email']:-webkit-autofill:hover, input[type='email']:-webkit-autofill:focus, input[type='email']:-webkit-autofill:active":
                    {
                        WebkitBoxShadow: `0 0 0 30px ${theme.palette.background.default} inset !important`,
                        WebkitTextFillColor: theme.palette.greySecondary.main,
                    },
            }),
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    marginTop: "4px !important",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: ({ theme }) => ({
                    th: {
                        backgroundColor: theme.palette.common.white,
                        color: theme.palette.greySecondary.main,
                        boxShadow: "none",
                    },
                }),
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    width: 52,
                    height: 34,
                    ".MuiSwitch-thumb": {
                        backgroundColor:
                            ownerState.checked === true
                                ? theme.palette[ownerState.color ? ownerState.color : "success"].main
                                : theme.palette.greySecondary[300],
                    },
                    ".Mui-checked": {
                        ".MuiSwitch-thumb": {
                            backgroundColor: theme.palette[ownerState.color ? ownerState.color : "success"].main,
                        },
                        "&.Mui-disabled": {
                            ".MuiSwitch-thumb": {
                                boxShadow: "none",
                                backgroundColor: theme.palette.success[100],
                            },
                            "+ .MuiSwitch-track": {
                                backgroundColor: theme.palette.success[50],
                            },
                        },
                    },
                    ".Mui-disabled": {
                        ".MuiSwitch-thumb": {
                            boxShadow: "none",
                            backgroundColor: theme.palette.greySecondary[200],
                        },
                        "+ .MuiSwitch-track": {
                            opacity: "1 !important",
                            backgroundColor: theme.palette.greySecondary[50],
                        },
                    },
                }),
                switchBase: {
                    left: 3,
                    "&.Mui-checked": {
                        transform: "translateX(12px)",
                    },
                },
                thumb: {
                    width: 16,
                    height: 16,
                },
                track: ({ theme }) => ({
                    opacity: 1,
                    backgroundColor: theme.palette.greySecondary[100],
                }),
            },
        },
        MuiButton: {
            styleOverrides: {
                // 기존 스타일 덮어쓰지 않도록 먼저 가져오기
                ...overrideComponents(projectTheme).MuiButton?.styleOverrides,

                sizeXsmall: ({ theme }) => ({
                    padding: theme.spacing(0, 1),
                    height: 24,
                    fontSize: theme.typography["body3"].fontSize,
                    [theme.breakpoints.down("sm")]: {
                        fontSize: `0.688rem`,
                    },
                }),
            },
        },
    },
};

const theme = PDCCreateTheme(projectOverrideTheme);
export default theme;
export const narrowTheme = PDCCreateTheme({ ...projectOverrideTheme, spacing: 7 });
